export default __webpack_public_path__ + "static/media/error.d0160d24.png";